import { Box, Typography } from '@mui/material';
import React, { FC, ReactNode } from 'react';
import { useStyles } from './MatchSummaryCard.styles';

interface MatchSummaryCardProps {
  image?: string;
  title?: string | ReactNode;
  description?: string | ReactNode;
  note?: string;
}

export const MatchSummaryCard: FC<MatchSummaryCardProps> = ({
  image,
  description,
  title,
  note,
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.imageContainer}>
        <img src={image} />
      </Box>
      <Box className={classes.titleContainer}>
        <Typography>{title}</Typography>
        <Typography>{description}</Typography>
        <Typography className={classes.note}>{note}</Typography>
      </Box>
    </Box>
  );
};
